/**
 * Declare Permissions key and values
 */
export interface Permissions {
  key: string;
  value: string;
}
